import * as actionType from "../actions/actionTypes";
const initialState = {
  isAuthenticated: false,
  sessionToken: null,
  error: "",
  user: {},
};

export default function (state = initialState, action) {
  switch (action.type) {
    case actionType.LOGIN_SUCCESS:
      return {
        ...state,

        user: action.payload.user,
        sessionToken: action.payload["x-metro-sessiontoken"],
        error: "",
      };
    case actionType.SET_USER:
      return {
        sessionToken: action.payload,
      };
    case actionType.LOGIN_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case actionType.SEND_OTP:
      return {
        ...state,
        ...action.payload,
        error:'Otp sent'
      };
    case actionType.VERIFY_OTP:
      return {
        ...state,
        ...action.payload,
        error:'otp verified'
      };
      case actionType.RESET_PASSWORD:
      return {
        ...state,
        ...action.payload,
        error:'password reset success !!'
      };
      case actionType.ERROR:
      return {
        ...state,
        error:action.payload,
      };
    case actionType.TWO_FA_CREATE:
      return {
        ...state,
        user: { ...state.user, ...action.payload },
      };
    case actionType.TWO_FA_VERIFY:
      return {
        ...state,
        user: { ...state.user, ...action.payload },
      };
    case actionType.TWO_FA_VALIDATE:
      return {
        ...state,
        user: { ...state.user, ...action.payload },
      };
    case actionType.TWO_FA_VERIFY_OTP: {
      return {
        ...state,
        user: {},
        error: "Otp verified Successfully, You can now add a new device for google auth",
      };
    }
    case actionType.TWO_FA_SEND_OTP: {
      return {
        ...state,
        error: "",
      };
    }
    case actionType.FIELDS_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    case actionType.RESET_STATE:
      return initialState;
    case actionType.SEND_OTP:
      return {
        ...state,
        ...action.payload,
        error:'Otp sent'
      };
    case actionType.VERIFY_OTP:
      return {
        ...state,
        ...action.payload,
        error:'otp verified'
      };
      case actionType.RESET_PASSWORD:
      return {
        ...state,
        ...action.payload,
        error:'password reset success !!'
      };
      case actionType.ERROR:
      return {
        ...state,
        error:action.payload,
      };
    default:
      return state;
  }
}
